import { CountUp } from 'countup.js';
import { sliders } from './sliders';

/**
 * Sets up the scrolled class
 */
export function setup_scrolling()
{
	let prevScroll = 0;

	$(window).on('scroll', function() {
		
		//Add the 'scrolled' class
		let scroll = $(this).scrollTop();
		let body = $('body');
		let header = $('.header');
		let fold = $(window).innerHeight() * 0.25;
		let half = $(window).innerHeight() * 0.5;

		if( body.hasClass('menu-active') )
		{
			return;
		}

		if(scroll > 0)
		{
			body.addClass('scrolled');
		}
		else
		{
			body.removeClass('scrolled');
		}

		if(scroll > half)
		{
			body.addClass('fold');
		}
		else
		{
			body.removeClass('fold');
		}

		if (scroll < prevScroll)
		{
			if( !body.hasClass('scrolling') )
			{
				header.addClass('scroll-up');
			}
		}
		else
		{
			header.removeClass('scroll-up');
		}
		
		prevScroll = scroll;
	});
}

export function sidebar()
{
	let sidebarShowHide = $('.sidebar--mobile').find('.sidebar__title');
	
	sidebarShowHide.on('click', function(){
		
		let parent = $(this).parent();
		let body = parent.find('.sidebar__body');

		if( parent.hasClass('active') )
		{
			parent.removeClass('active');

			setTimeout(() => {
				body.slideUp(400);
			}, 200 );
		}
		else
		{
			body.slideDown(400);

			setTimeout(() => {
				parent.addClass('active');
			}, 200 );
		}
	});

	$('.sidebar-item__trigger').on('click', function(){
		let _this = $(this);
		let parent = _this.parent();
		let id = _this.attr('data-id');
		let section = $('.content-section').find(`[data-id="${id}"]`);
		let body = $('body');

		if( section.length > 0 )
		{
			let offset = section.offset().top - 100;

			parent.addClass('active').siblings().removeClass('active');
			body.addClass('scrolling');

			$('html, body').animate({
				scrollTop: offset,
			}, 800, () => {

				setTimeout(() => {
					body.removeClass('scrolling');
				}, 200 );

				if( $('.sidebar').hasClass('active') )
				{
					$('.sidebar').removeClass('active');

					setTimeout(() => {
						$('.sidebar__body').slideUp(400);
					}, 200 );
				}
			});
		}
	})
}

export function counter(parent)
{

	let counter_parent = $(parent);
	
	let counter = counter_parent.find('.counter');
	counter.each(function(index)
	{
		let _this = $(counter[index]);
		let value = _this.attr('data-end');

		let slide = _this.parents('.owl-item.active');

		function count_end()
		{
			!slide.hasClass('visited') ? slide.addClass('visited') : false;
		}

		let timing = 2;

		if( value <= 10 )
		{
			timing = 1;	
		}

		let options = {
			duration: timing,
		};

		if( slide.hasClass('active') )
		{
			let counterAnimation = new CountUp(counter[index], value, options);
			counterAnimation.start(count_end);
		}
	})
}

export function lazyload(active_section)
{
	let lazy = active_section.find('.lazy');

	lazy.each(function() {

		let image = document.createElement('img');

		let _this = $(this);
		let lazy_el = _this.find('[data-src]');
		let image_src = lazy_el.attr('data-src');

		if( _this.hasClass('lazy-loaded') )
		{
			return;
		}

		image.onload = () => {

			if(lazy_el.is('img'))
			{
				lazy_el.attr('src', image_src);
			}
			else
			{
				lazy_el.css('background-image', `url(${image_src})`);
			}
		}
		image.onerror = function () {
			console.log('Could not load image')
		}

		setTimeout(() => {
			_this.addClass('lazy-loaded');
		}, 200 );

		image.src = image_src;
	});
}




// WEBPACK FOOTER //
// ./scripts/modules/page.js